__turbopack_context__.v({
  "lined": "Table-module__P1YERa__lined",
  "regular": "Table-module__P1YERa__regular",
  "scroller": "Table-module__P1YERa__scroller",
});
